var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1:300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7272 0.0350297L0.373266 5.69174C0.130027 5.78306 -0.0243204 6.02791 0.0031552 6.28812C0.0298227 6.54914 0.230232 6.75763 0.489633 6.79399L8.55045 7.94554L9.702 16.0064C9.73836 16.2658 9.94766 16.467 10.2071 16.4936C10.3832 16.513 10.5529 16.4484 10.6717 16.3296C10.7291 16.2722 10.7744 16.2027 10.8034 16.1235L16.4601 0.769594C16.5377 0.559488 16.486 0.325138 16.3284 0.167559C16.1709 0.00997888 15.9365 -0.0417397 15.7272 0.0350297Z",
    fill: "#FDBF5A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1:300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7272 0.0350297L0.373266 5.69174C0.130027 5.78306 -0.0243204 6.02791 0.0031552 6.28812C0.0298227 6.54914 0.230232 6.75763 0.489633 6.79399L8.55045 7.94554L9.702 16.0064C9.73836 16.2658 9.94766 16.467 10.2071 16.4936C10.3832 16.513 10.5529 16.4484 10.6717 16.3296C10.7291 16.2722 10.7744 16.2027 10.8034 16.1235L16.4601 0.769594C16.5377 0.559488 16.486 0.325138 16.3284 0.167559C16.1709 0.00997888 15.9365 -0.0417397 15.7272 0.0350297Z",
    fill: "#FDBF5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3583 -0.77063L8.35828 8.22937C8.85828 11.5627 9.85828 18.3294 9.85828 18.7294C9.85828 19.1294 13.8583 18.896 15.8583 18.7294L17.3583 -0.77063Z",
    fill: "#E5AB4C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.af415bf3dc69a140243afa1221e172a6.svg";
export { ForwardRef as ReactComponent };